<template>
<mainTemplateVue>
    <div>
        <md-toolbar :md-elevation="0" class="md-transparent">
            <h3 class="md-title">{{ $route.name }}</h3>
            <md-button class="md-primary" to="/estoque">Voltar</md-button>
        </md-toolbar>
        
        <div>
            <md-card>
                <md-card-content>
                    <form class="md-layout">
                        <md-field :class="getValidationClass('estoqueItem_nome')">
                            <label for="estoqueItem_nome">Nome</label>
                            <md-input v-model="form.estoqueItem_nome" name="estoqueItem_nome" id="estoqueItem_nome" :disabled="sending" required/>
                            <span class="md-error" v-if="!$v.form.estoqueItem_nome.required">O nome do item é obrigatório</span>
                        </md-field>

                        <md-field :class="getValidationClass('estoqueItem_estoqueMinimo')">
                            <label for="estoqueItem_estoqueMinimo">Estoque minimo</label>
                            <md-input type="number" v-model="form.estoqueItem_estoqueMinimo" name="estoqueItem_estoqueMinimo" id="estoqueItem_estoqueMinimo"  :disabled="sending" required/>
                            <span class="md-error" v-if="!$v.form.estoqueItem_estoqueMinimo.required">Insira uma quantidade de estoque minimo para este item</span>
                        </md-field>
                        <md-field :class="getValidationClass('estoqueItem_quantidade')">
                            <label for="estoqueItem_quantidade">Quantidade em estoque</label>
                            <md-input 
                            type="number" 
                            v-model="form.estoqueItem_quantidade" 
                            name="estoqueItem_quantidade" 
                            id="estoqueItem_quantidade"  
                            :disabled="sending" required/>

                            <span class="md-error" v-if="!$v.form.estoqueItem_quantidade.required">Insira a quantidade disponivel em estoque</span>
                        </md-field>

                        <md-field :class="getValidationClass('unidadeMedida_id')">
                            <label for="unidadeMedida_id">Unidade de Medida</label>
                            <md-select v-model="form.unidadeMedida_id" name="unidadeMedida_id" id="unidadeMedida_id">
                                <md-option v-for="item in unidadesMedida" :key="item.unidadeMedida_id" :value="item.unidadeMedida_id">
                                    {{item.unidadeMedida_nome}}
                                </md-option>
                            </md-select>
                            <span class="md-error" v-if="!$v.form.unidadeMedida_id.required">Selecione a unidade medida para este item</span>
                        </md-field>
                        
                        <preco-minimo 
                        :validationClass="getValidationClass('estoqueItem_precoMinimo')"
                        :requiredValidation="!$v.form.estoqueItem_precoMinimo.required"
                        :sending="sending"
                        required 
                        v-model="form.estoqueItem_precoMinimo"
                        :options="currencySettings" />
                    </form>
                </md-card-content>
                
                <md-card-actions md-alignment="left">
                    <md-button class="md-primary" @click="saveAndToList" :disabled="sending">Salvar</md-button>
                    <md-button class="md-primary" :disabled="sending" @click="saveAndCreateNew">Salvar e criar novo</md-button>
                    <md-button class="md-accent" :disabled="sending" @click="cancel">Cancelar</md-button>
                </md-card-actions>
            </md-card>
        </div>

        <md-snackbar :md-active.sync="showSnackMessage">{{snackMessage}}</md-snackbar>
    </div>
</mainTemplateVue>
</template>

<script>
import mainTemplateVue from '../../components/main-template.vue'
import PrecoMinimo from './Inputs/PrecoMinimo.vue'
import { validationMixin } from 'vuelidate'
  import {
    required,
    minLength
  } from 'vuelidate/lib/validators'
import { api } from '../../services/api'

export default {
    name: 'estoqueItemForm',
    components: {
        mainTemplateVue,
        PrecoMinimo 
    },
    mixins: [validationMixin],
    data: () => ({
        id: null,
        valorTotalSimulado: '',
        seekingError: false,
        showSnackMessage: false,
        unidadesMedida: [],
        snackMessage: false,
        sending: false,
        saved: false,
        error: false,
        form: {
            estoqueItem_nome: '',
            estoqueItem_estoqueMinimo: null,
            estoqueItem_precoMinimo: null,
            estoqueItem_quantidade: null,
            unidadeMedida_id: null
        },
        currencySettings: {
            currency: "BRL",
            currencyDisplay: "narrowSymbol",
            precision: 2,
            hideCurrencySymbolOnFocus: false,
            hideGroupingSeparatorOnFocus: true,
            hideNegligibleDecimalDigitsOnFocus: false,
            autoDecimalDigits: true,
            autoSign: false,
            useGrouping: false,
            accountingSign: false
        }
    }),
    validations: {
      form: {
        estoqueItem_nome: {
          required,
          minLength: minLength(3)
        },
        estoqueItem_estoqueMinimo: {
            required
        },
        estoqueItem_precoMinimo: {
            required
        },
        estoqueItem_quantidade: {
            required
        },
        unidadeMedida_id: {
            required
        }
      }
    },
    watch: {
        
    },
    methods: {
        getValidationClass (fieldName) {
            const field = this.$v.form[fieldName]

            if (field) {
                return {
                    'md-invalid': field.$invalid && field.$dirty
                }
            }
        },
        async saveAndCreateNew(){
            this.$v.$touch()

            if(!this.$v.$invalid){
                this.save().then(() => {
                    this.form.estoqueItem_nome = '',
                    this.form.estoqueItem_estoqueMinimo = null,
                    this.form.estoqueItem_precoMinimo = null,
                    this.form.estoqueItem_quantidade = null,
                    this.form.unidadeMedida_id = null
                }).catch(() => {
                    this.error = true
                })
            }
        },

        async saveAndToList(){
            this.$v.$touch()

            if(!this.$v.$invalid){
                this.save().then(() => setTimeout(() => { this.$router.push({ path: '/estoque' }) }, 1000))
                .catch(() => this.error = true )
            }
        },

        async save(){
            this.sending = true

            let res;

            if(this.id !== null) {
                res = await api().put(`/estoque/item/${this.id}`, this.form)
            } else {
                res = await api().post('/estoque/item', this.form)
            }

            this.sending = false
            this.showSnackMessage = true
            this.snackMessage = true
                
            if(!res) {
                this.snackMessage = "Ocorreu um erro ao salvar o registro"
                return false
            }
            
            this.snackMessage = "Registro salvo com sucesso"

            return true
        },

        async getItem(){
            this.sending = true

            let res = await api().get(`/estoque/item/${this.id}`)

            console.log(res)

            if(!res){
                this.seekingError = true
                return false
            }

            this.sending = false
            this.form = { ...res.data.data }
            this.form.es
        },

        cancel(){
            this.$router.push({ path: '/estoque' })
        },

        async getUnidadesMedida(){
            let req = await api().get('estoque/medida')
            this.unidadesMedida = req.data.data
        }
    },
    created () {
        this.getUnidadesMedida()

        if(this.$route.params.id && !isNaN(this.$route.params.id)) {
            this.id = this.$route.params.id
            this.getItem()
        }
    },

    mounted() {
    }
}
</script>

<style>
.md-radio {
    display: flex;
}
</style>